import React from 'react';
import Alert from 'app/components/general/Alert';
import Isvg from 'react-inlinesvg';

import CancelIcon from 'app/images/icons/cancel.svg';

interface INotificationProps {
  id: string;
  key: string;
  color: string;
  className: string;
  onClick: any;
  handleClose: any;
}

interface INotificationState {
  closed: boolean;
}

export default class Notification extends React.Component<
INotificationProps,
INotificationState
> {
  static defaultProps: INotificationProps = {
    id: undefined,
    key: undefined,
    onClick: undefined,
    handleClose: undefined,
    className: undefined,
    color: 'info',
  };

  readonly state: INotificationState = {
    closed: false,
  };

  handleClick = (e): void => {
    // console.log(e.target.classList);
    if (this.props.onClick !== undefined && !e.target.classList.contains('notification-cancel-icon')) {
      this.props.onClick();
    }
  };

  handleClose = (e): void => {
    e.stopPropagation();
    e.preventDefault();
    this.props.handleClose(this.props.id);
  };

  render(): React.ReactNode {
    if (!this.state.closed) {
      return (
        <div onClick={this.handleClick} className={this.props.className}>
          <Alert color={this.props.color} className="notification-alert">
            <div className="notification-text">{this.props.children}</div>
            {this.props.handleClose !== undefined && (
              <div className="notification-cancel" onClick={this.handleClose}>
                <Isvg className="notification-cancel-icon" src={CancelIcon} />
              </div>
            )}
          </Alert>
        </div>
      );
    }
    return null;
  }
}
